import {
  coreExtensionData,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import techDocsPlugin from '@backstage/plugin-techdocs/alpha';
import { TechDocsReaderPageWithAnalytics } from './components';

const customTechDocsReaderPageExtension = techDocsPlugin
  .getExtension('page:techdocs/reader')
  .override({
    factory(originalFactory) {
      const originalOutput = originalFactory();
      const originalElement = originalOutput.get(
        coreExtensionData.reactElement,
      );
      return [
        ...originalOutput,
        coreExtensionData.reactElement(
          <TechDocsReaderPageWithAnalytics>
            {originalElement}
          </TechDocsReaderPageWithAnalytics>,
        ),
      ];
    },
  });

export const techdocsModuleCustomAnalytics = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [customTechDocsReaderPageExtension],
});
